// src/components/ProgressChecklist.jsx
import React from "react";

export default function ProgressChecklist({
  cov,                // { totalUnits, warehouse, container, lome, pctWarehouse, pctContainer, pctLome }
  paidTotalXOF = 0,
  estimateXOF = 0,
  payStatus = "non_defini",
  issues = [],        // incohérences détectées
}) {
  const labelPay = {
    non_defini: "Estimation non définie",
    non_paye: "Non payé",
    partiel: "Payé partiellement",
    solde: "Soldé",
  }[payStatus] || payStatus;

  const badge = (ok, partial, zero) => {
    if (ok) return <span className="badge bg-success">Complet</span>;
    if (partial) return <span className="badge bg-warning text-dark">Partiel</span>;
    return <span className="badge bg-secondary">0%</span>;
  };

  const Progress = ({ value }) => (
    <div className="progress" role="progressbar" aria-valuenow={value} aria-valuemin="0" aria-valuemax="100">
      <div className="progress-bar" style={{ width: `${value}%` }}>{value}%</div>
    </div>
  );

  return (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <h6 className="mb-3">Contrôle avant enregistrement</h6>

        {/* Paiement */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <strong>Paiements</strong>
            <span className={`badge ${
              payStatus === "solde" ? "bg-success"
              : payStatus === "partiel" ? "bg-warning text-dark"
              : "bg-secondary"
            }`}>
              {labelPay}
            </span>
          </div>
          <div className="small text-muted mt-1">
            Payé: <strong>{Number(paidTotalXOF || 0).toLocaleString("fr-FR")} XOF</strong>
            {" · "}Estimation: <strong>{Number(estimateXOF || 0).toLocaleString("fr-FR")} XOF</strong>
          </div>
        </div>

        {/* Étapes */}
        <div className="row g-3">
          <div className="col-md-4">
            <div className="border rounded p-2">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span>Entrepôt (Chine)</span>
                {badge(cov.pctWarehouse === 100, cov.pctWarehouse > 0 && cov.pctWarehouse < 100, cov.pctWarehouse === 0)}
              </div>
              <Progress value={cov.pctWarehouse} />
              <div className="small text-muted mt-1">
                {cov.warehouse} / {cov.totalUnits} unités
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="border rounded p-2">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span>Mise en conteneur</span>
                {badge(cov.pctContainer === 100, cov.pctContainer > 0 && cov.pctContainer < 100, cov.pctContainer === 0)}
              </div>
              <Progress value={cov.pctContainer} />
              <div className="small text-muted mt-1">
                {cov.container} / {cov.totalUnits} unités
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="border rounded p-2">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span>Réception à Lomé</span>
                {badge(cov.pctLome === 100, cov.pctLome > 0 && cov.pctLome < 100, cov.pctLome === 0)}
              </div>
              <Progress value={cov.pctLome} />
              <div className="small text-muted mt-1">
                {cov.lome} / {cov.totalUnits} unités
              </div>
            </div>
          </div>
        </div>

        {/* Manquants */}
        <div className="mt-3 small">
          {cov.totalUnits > 0 && (
            <>
              <div>Manque à l’entrepôt : <strong>{Math.max(0, cov.totalUnits - cov.warehouse)}</strong></div>
              <div>Manque en conteneur : <strong>{Math.max(0, cov.totalUnits - cov.container)}</strong></div>
              <div>Manque à Lomé : <strong>{Math.max(0, cov.totalUnits - cov.lome)}</strong></div>
            </>
          )}
        </div>

        {/* Avertissements de cohérence */}
        {issues.length > 0 && (
          <div className="alert alert-warning mt-3 mb-0">
            <div className="fw-bold mb-1">Vérifications à corriger :</div>
            <ul className="mb-0">
              {issues.map((msg, i) => <li key={i}>{msg}</li>)}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
